import type { ApiEndpointBuilder } from "../apiEndpointHelpers";

/** `GET /admin/v2/live-alerts/count`: the signed-in admin's actionable alerts. */
export interface AdminV2LiveAlertsCountResponse {
  staffUserId: string;
  count: number;
  byStatus: Record<string, number>;
  generatedAt: string;
  cachedUntil: string;
}

/**
 * Sidebar badge polling. Each poll outlasts the server's 45s per-admin
 * cache, so every poll is a full read; two minutes keeps that cost down,
 * and the admin's own changes re-read at once. Reassigning an alert to
 * someone else reaches their badge on their next poll.
 */
export const LIVE_ALERTS_COUNT_POLL_MS = 120_000;

let freshRequested = false;

/**
 * The admin's own snooze, resolve or quick action should never leave the
 * badge behind: the next count read bypasses the server's short cache.
 */
export const requestFreshLiveAlertsCount = () => {
  freshRequested = true;
};

export const buildAdminV2LiveAlertCountEndpoints = (
  builder: ApiEndpointBuilder,
) => ({
  getAdminV2LiveAlertsCount: builder.query<
    AdminV2LiveAlertsCountResponse,
    void
  >({
    query: () => {
      const fresh = freshRequested;
      freshRequested = false;
      return {
        url: "/admin/v2/live-alerts/count",
        ...(fresh ? { params: { fresh: "1" } } : {}),
      };
    },
    providesTags: [{ type: "AdminV2LiveAlerts", id: "COUNT" }],
  }),
});
